var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"400px","margin":"0 auto"}},[_c('barchart',{attrs:{"options":_vm.chart_options,"chart-data":_vm.getData()}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }